import React, { useState } from 'react';
import styled, { css } from '../../styled/index';
import LoadingSpinner from '../loadingSpinner';
const Container = styled.div `
  display: flex;
`;
const ImageWrapper = styled.div `
  text-align: center;
  position: relative;
  cursor: ${({ disableHover }) => (disableHover ? 'unset' : 'pointer')};
  background-color: ${({ theme }) => theme.colors.SNOW_100};
  max-width: ${({ theme, size }) => theme.imagePreview.types[size].maxWidth};
  max-height: ${({ theme, size }) => theme.imagePreview.types[size].maxHeight};

  &,
  &:hover::before {
    border-radius: ${({ theme, size }) => theme.imagePreview.types[size].borderRadius}px;
    overflow: hidden;
  }

  &:active {
    ::before {
      opacity: 0.4;
    }
  }

  > div {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    z-index: 999;
  }

  ${({ size, theme }) => size === 'LARGE' &&
    css `
      border: 0.0625rem solid ${theme.colors.INK_200};
    `};

  ${({ disableHover, theme }) => !disableHover &&
    css `
      &:hover {
        ::before {
          content: '';
          display: block;
          height: 100%;
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          background-color: ${theme.colors.INK_200};
          opacity: 0.2;
        }
      }
    `};

  ${({ isLoading, theme, size }) => isLoading &&
    css `
      width: ${theme.imagePreview.types[size].maxWidth};
      height: ${theme.imagePreview.types[size].maxHeight};
    `};
`;
const Image = styled.img `
  display: block;
  width: 100%;
  height: 100%;
`;
const LoadingWrapper = styled.div `
  width: 4rem;
  height: 4rem;

  ::before {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    border-radius: 50%;
    opacity: 0.3;
    background-color: ${({ theme }) => theme.colors.BLACK};
  }

  > svg {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
`;
const imagePreviewGenerator = (sizeKey) => ({ image, disableHover = false, onLoad = () => { }, onClick, }) => {
    const [isLoading, setIsLoading] = useState(true);
    const handleImageLoaded = () => {
        setIsLoading(false);
        onLoad();
    };
    return (React.createElement(Container, null,
        React.createElement(ImageWrapper, { onClick: onClick, size: sizeKey, isLoading: isLoading, disableHover: disableHover },
            React.createElement(Image, { src: image, onLoad: handleImageLoaded, onError: handleImageLoaded }),
            sizeKey !== 'SMALL' && isLoading && (React.createElement(LoadingWrapper, null,
                React.createElement(LoadingSpinner, { color: "SNOW_200", size: 32 }))))));
};
export const Default = imagePreviewGenerator('LARGE');
export const QuickView = imagePreviewGenerator('MEDIUM');
export const Thumbnail = imagePreviewGenerator('SMALL');
//# sourceMappingURL=ImagePreview.js.map